import type { ThemeConfig } from 'antd';
import theme from '@/styles/themes/theme-config';

const light: ThemeConfig = {
  token: {
    fontSize: 14,
    colorPrimary: theme.primaryColor,
  },
  components: {
    Menu: {
      colorItemTextHover: '#000',
      colorItemTextSelected: '#000',
    },
  },
};

export default light;
